module.exports = __webpack_public_path__ + "img/table-pasport-icon.a4892ab4.svg";